import { IUserData, UserModel, UserStatus } from "@truckdown/accounts";
import { defineComponent, ref, Ref, watch, onMounted } from 'vue';
import context from '@truckdown/systems';
import { isCsrOrAdmin, isUserInRole } from "../../Utilities/Utilities"

interface IData {
    sortNameAsc: Ref<boolean>,
    sortNameDesc: Ref<boolean>,
    sortEmailAsc: Ref<boolean>,
    sortEmailDesc: Ref<boolean>,
    sortMobileAsc: Ref<boolean>,
    sortMobileDesc: Ref<boolean>,
    sortStatusAsc: Ref<boolean>,
    sortStatusDesc: Ref<boolean>,
    sortLastModifiedAsc: Ref<boolean>,
    sortLastModifiedDesc: Ref<boolean>,
    sortRightsAsc: Ref<boolean>,
    sortRightsDesc: Ref<boolean>,
    sortedArray: Ref<UserModel[]>,
    errorMessage: Ref<string>

}

const getInitialData = function (props: any) {
    return {
        sortNameAsc: ref<boolean>(false),
        sortNameDesc: ref<boolean>(false),
        sortEmailAsc: ref<boolean>(false),
        sortEmailDesc: ref<boolean>(false),
        sortMobileAsc: ref<boolean>(false),
        sortMobileDesc: ref<boolean>(false),
        sortStatusAsc: ref<boolean>(false),
        sortStatusDesc: ref<boolean>(false),
        sortLastModifiedAsc: ref<boolean>(false),
        sortLastModifiedDesc: ref<boolean>(false),
        sortRightsAsc: ref<boolean>(false),
        sortRightsDesc: ref<boolean>(false),
        sortedArray: ref<UserModel[]>(props.users),
        errorMessage: ref<string>("")
    }
}

const listEvents = {
    sort: 'sort'
}

const resetSortBy = function (data: IData) {
    data.sortNameAsc.value = false;
    data.sortNameDesc.value = false;
    data.sortEmailAsc.value = false;
    data.sortEmailDesc.value = false;
    data.sortMobileAsc.value = false;
    data.sortMobileDesc.value = false;
    data.sortStatusAsc.value = false;
    data.sortStatusDesc.value = false;
    data.sortLastModifiedAsc.value = false;
    data.sortLastModifiedDesc.value = false;
    data.sortRightsAsc.value = false;
    data.sortRightsDesc.value = false;
}

const getMethods = function (data: IData, ctx: any) {
    return {
        closePurgedUsers: function () {
            console.log("GS closePurgedUsers");
            ctx.emit('close-purged-users');
        },
        sortBy: function (field: string) {
            field = field.toLowerCase();
            resetSortBy(data);

            if (field == "name_asc") {
                data.sortedArray.value.sort((a, b) => a.firstName.localeCompare(b.firstName));
                data.sortNameAsc.value = true;
            } else if (field == "name_desc") {
                data.sortedArray.value.sort((a, b) => b.firstName.localeCompare(a.firstName));
                data.sortNameDesc.value = true;
            } else if (field == "email_asc") {
                data.sortedArray.value.sort((a, b) => a.email.localeCompare(b.email));
                data.sortEmailAsc.value = true;
            } else if (field == "email_desc") {
                data.sortedArray.value.sort((a, b) => b.email.localeCompare(a.email));
                data.sortEmailDesc.value = true;
            } else if (field == "mobile_asc") {
                data.sortedArray.value.sort((a, b) => (a.mobile ?? "").localeCompare(b.mobile ?? ""));
                data.sortMobileAsc.value = true;
            } else if (field == "mobile_desc") {
                data.sortMobileDesc.value = true;
                data.sortedArray.value.sort((a, b) => (b.mobile ?? "").localeCompare(a.mobile ?? ""));
            } else if (field == "status_asc") {
                data.sortedArray.value.sort((a, b) => a.status - b.status);
                data.sortStatusAsc.value = true;
            } else if (field == "status_desc") {
                data.sortedArray.value.sort((a, b) => b.status - a.status);
                data.sortStatusDesc.value = true;
            } else if (field == "lastmodified_asc") {
                data.sortedArray.value.sort((a, b) => a.modified.toString().localeCompare(b.modified.toString()));
                data.sortLastModifiedAsc.value = true;
            } else if (field == "lastmodified_desc") {
                data.sortedArray.value.sort((a, b) => b.modified.toString().localeCompare(a.modified.toString()));
                data.sortLastModifiedDesc.value = true;
            } else if (field == "rights_asc") {
                data.sortedArray.value.sort((a, b) => this.getRole(a).localeCompare(this.getRole(b)));
                data.sortRightsAsc.value = true;
            } else if (field == "rights_desc") {
                data.sortedArray.value.sort((a, b) => this.getRole(b).localeCompare(this.getRole(a)));
                data.sortRightsDesc.value = true;
            } else {
                data.sortedArray.value.sort((a, b) => a.firstName.localeCompare(b.firstName));
                data.sortNameAsc.value = true;
            }
        },
        getRole: function (user: UserModel) {
            if (isUserInRole(user, "System Admin") == true) {
                return "System Admin";
            } else if (isUserInRole(user, "TruckDown CSR") == true) {
                return "TruckDown CSR";
            } else if (isUserInRole(user, "General Admin") == true) {
                return "Admin";
            } else {
                return "";
            }
        },
        getViewUserLink: function (user: UserModel) {
            return `/accounts/admin/user/${encodeURIComponent(user.id)}`;
        },
        getProfilePicture: function (user: UserModel) {
            return context.profileImagePath + user.settings.profilepic;
        },
        formatPhoneString: function (phone: string) {
            if (phone?.length == 10) {
                phone = phone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
            }
            return phone;
        },
        getStatus: function (status: UserStatus) {
            return UserStatus[status];
        },
        dateDisplay: function (dateUTC: Date | string): Date | string | undefined {
            if (dateUTC) {
                return new Date(dateUTC).toLocaleString();
            } else
                return undefined;
        },
        isInvitedUser: function (status: UserStatus): Boolean {
            return status == UserStatus.Invited;
        },

    };
}

const getPurgedUsers = async function (accountNumber: number, data: IData) {
    let userData = await context.getService<IUserData>('IUserData');
    let response = await userData.getPurgedUsers(accountNumber);

    console.log("GS getPurgedUsers users:", response);

    if (response && response.ok) {
        data.sortedArray.value = response.data ?? [];
    } else {
        data.sortedArray.value = [];
    }
}

export default defineComponent({
    name: "PurgedUsers",
    props: {
        accountNumber: {
            type: Number,
            required: true
        }
    },
    emits: [listEvents.sort],
    setup: function (props, ctx) {
        console.log("GS PurgedUsers setup() props: ", props);

        let data = getInitialData(props);
        let methods = getMethods(data, ctx);

        onMounted(async () => {
            await getPurgedUsers(props.accountNumber, data);
        });

        return {
            ...data,
            ...methods
        }
    }
});